// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"d6c5215d","513":"df891d55","545":"310380c2","787":"763f5684"}[chunkId] + ".chunk.js";
};